<template>
  <a-button icon="fullscreen" shape="circle" size="small" @click="fullScreen"/>
</template>

<script>
  import screenfull from 'screenfull'
  export default {
    name: 'ScreenFull',
    data(){
      return{
        isFullscreen: false
      }
    },
    methods:{
      fullScreen(){
        // 需要注意的是 如果判断!screenfull.enabled 显示的是不支持全屏的话 是因为谷歌的版本问题  判断改为 !screenfull.isEnabled  就可以了
        if (!screenfull.isEnabled) { // 如果不允许进入全屏，发出不允许提示
          this.$message({
            message: '当前浏览器不支持全屏',
            type: 'warning'
          })
          return false
        }
        screenfull.toggle()
        // this.$message({
        //   message: '全屏啦',
        //   type: 'success'
        // })
      }
    }
  }
</script>

<style scoped>

</style>